import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const AccessRequestSettingsPageLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AccessRequestSettingsPage" */ './AccessRequestSettingsPage.tsx'
			)
		).AccessRequestSettingsPage,
});
